<template>
<div>
    <div class="content">
        <div class="full">
            <div class="full">
                <div class="subheader">
                    {{ $t('store.templates.leisure') }}
                </div>
            </div>
            <div class="full split">
                <div class="full">
                    <div class="threefourths" style="margin-top: 8px;">
                        <div class="label" style="text-align: left;">
                            {{ $t('store.templates.leisureHelp') }}
                        </div>
                    </div>
                </div>
                <div class="tenth">
                    <div class="header">
                        <div class="label">{{ $t('store.templates.actions') }}</div>
                    </div>
                </div>
                <div class="twotenths">
                    <div class="header">
                        <div class="label">{{ $t('pages.employeeData.name') }}</div>
                    </div>
                </div>
                <div class="tenth">
                    <div class="header">
                        <div class="label center">{{ $t('store.templates.wishes') }}</div>
                    </div>
                </div>
                <div class="tenth">
                    <div class="header">
                        <div class="label center">{{ $t('store.templates.dislikes') }}</div>
                    </div>
                </div>
                <div class="tenth">
                    <div class="header">
                        <div class="label center">{{ $tc('store.templates.weekends', 2) }}</div>
                    </div>
                </div>
                <div class="tenth">
                    <div class="header">
                        <div class="label center">{{ $tc('store.templates.weekendDays', 2) }}</div>
                    </div>
                </div>
                <div class="tenth">
                    <div class="header">
                        <div class="label center">{{ $t('pages.employeeContext.skills') }}</div>
                    </div>
                </div>
                <div class="tenth">
                    <div class="header">
                        <div class="label center">{{ $t('store.templates.fairness') }}</div>
                    </div>
                </div>
                <div class="tenth">
                    <div class="header">
                        <div class="label center">{{ $t('store.templates.biorhythm') }}</div>
                    </div>
                </div>
            </div>
            <div v-for="t in employeeRulesTemplateMap" v-bind:key="t.id" class="full h34 split-bottom-tight">
                <div class="tenth left">
                    <button class="pill info-bg" @click="openEditPopup(t, true)">
                        <i class="fas fa-info" style="margin-left: -1px;"></i>
                    </button>
                    <button class="pill warn-bg ml5" @click="openEditPopup(t)">
                        <i class="fas fa-edit" style="margin-left: -1px;"></i>
                    </button>
                    <button class="pill danger-bg ml5" @click="openDeletePopup(t)">
                        <i class="fas fa-trash" style="margin-left: -1px;"></i>
                    </button>
                </div>
                <div class="twotenths">
                    <div class="label">{{ t.name }}</div>
                </div>
                <div class="tenth">
                    <div v-if="ruleSettingMap[t.id].desiredRSetting == 0"><i class="fas fa-times"></i></div>
                    <div v-else>{{ '[' + t.rules.desiredR.min + '...' + t.rules.desiredR.max + ']' }}</div>
                </div>
                <div class="tenth">
                    <div v-if="ruleSettingMap[t.id].undesiredRSetting == 0"><i class="fas fa-times"></i></div>
                    <div v-else>{{ '[' + t.rules.undesiredR.min + '...' + t.rules.undesiredR.max + ']' }}</div>
                </div>
                <div class="tenth">
                    <div v-if="ruleSettingMap[t.id].weekendRSetting == 0"><i class="fas fa-times"></i></div>
                    <div v-else>{{ '[' + t.rules.weekendR.min + '...' + t.rules.weekendR.max + ']' }}</div>
                </div>
                <div class="tenth">
                    <div v-if="ruleSettingMap[t.id].weekendDaysRSetting == 0"><i class="fas fa-times"></i></div>
                    <div v-else>{{ '[' + t.rules.weekendDaysR.min + '...' + t.rules.weekendDaysR.max + ']' }}</div>
                </div>
                <div class="tenth">
                    <div v-if="ruleSettingMap[t.id].skillRSetting == 0"><i class="fas fa-times"></i></div>
                    <div v-else><i class="fas fa-check"></i></div>
                </div>
                <div class="tenth">
                    <div v-if="ruleSettingMap[t.id].fairnessDefinitionRSetting == 0"><i class="fas fa-times"></i></div>
                    <div v-else>
                        {{ '[' + t.rules.fairnessDefinitionR.min + '...' + t.rules.fairnessDefinitionR.max + ']' }}
                    </div>
                </div>
                <div class="tenth">
                    <div v-if="ruleSettingMap[t.id].bioRSetting == 0"><i class="fas fa-times"></i></div>
                    <div v-else>{{ '[' + t.rules.bioR.min + '...' + t.rules.bioR.max + ']' }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    name: 'storeplanningguidelinesemployeerules',
    data() {
        return {
            fields: [{
                key: "name",
                label: this.$t('pages.employeeData.name'),
                thClass: 'documentsTh',
                tdClass: 'documentsTd'
            }, {
                key: "actions",
                label: "",
                thClass: 'documentsTh',
                tdClass: 'documentsTd',
                sortable: false
            }],
            currentTemplateRow: undefined,
            ruleTemplate: {
                name: "",
                desiredRSetting: 0,
                desiredRMin: 0,
                desiredRMax: 0,
                undesiredRSetting: 0,
                undesiredRMin: 0,
                undesiredRMax: 0,
                weekendRSetting: 0,
                weekendRMin: 0,
                weekendRMax: 0,
                weekendDaysRSetting: 0,
                weekendDaysRMin: 0,
                weekendDaysRMax: 0,
                skillRSetting: 0,
                fairnessDefinitionRSetting: 0,
                fairnessDefinitionRMin: 0,
                fairnessDefinitionRMax: 0,
                bioRSetting: 0,
                bioRMin: 0,
                bioRMax: 0,
                limitEmployeeCount: false,
                employeeCountMax: null
            },
            templateerror: false,
        }
    },
    created: function () {
        if (this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'employeeRulesTemplateMap']),
        ruleSettingMap(){
            let map = {};
            Object.values(this.employeeRulesTemplateMap).forEach(entry => {
                let mapItem = {};
                mapItem.desiredRSetting = this.determineRadioSetting(entry.rules.desiredR.min, entry.rules.desiredR.max);
                mapItem.undesiredRSetting = this.determineRadioSetting(entry.rules.undesiredR.min, entry.rules.undesiredR.max);
                mapItem.weekendRSetting = this.determineRadioSetting(entry.rules.weekendR.min, entry.rules.weekendR.max);
                mapItem.weekendDaysRSetting = this.determineRadioSetting(entry.rules.weekendDaysR.min, entry.rules.weekendDaysR.max);
                mapItem.skillRSetting = this.determineRadioSetting(entry.rules.skillR.min, entry.rules.skillR.max);
                mapItem.fairnessDefinitionRSetting = this.determineRadioSetting(entry.rules.fairnessDefinitionR.min, entry.rules.fairnessDefinitionR.max);
                mapItem.bioRSetting = this.determineRadioSetting(entry.rules.bioR.min, entry.rules.bioR.max);
                map[entry.id] = mapItem;
            });
            return map;
        }
    },
    watch: {
        storeId(newVal, oldVal){
            this.refresh();
        }
    },
    // methods that implement data logic.
    methods: {
        loadingStart(){
            this.$emit('update-loading-state', true);
        },
        loadingStop(){
            this.$emit('update-loading-state', false);
        },
        refresh: function (force = false) {
            let view = this;
            view.loadingStart();
            this.$helpers.GetEmployeeRulesTemplateMap(force)
            .then(map => {
                view.loadingStop();
            }).catch(function (error) {
                view.loadingStop();
                console.log(error)
            })

        },
        getLabel(ruleSetting) {
            if (ruleSetting === 1) {
                return "erlaubt";
            } else if (ruleSetting === 2) {
                return "unbedingt";
            } else {
                return "nicht erlaubt";
            }
        },
        createRuleTemplate(inputData) {
            let view = this;
            view.loadingStart();
            let url = '/api/sec/ruletemplate';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruletemplate');

            let payload = {
                storeId: this.$store.state.storeId,
                name: inputData.name,
                rules: {}
            }
            if (inputData.desiredRSetting) {
                payload.rules.desiredR = {
                    min: inputData.desiredRSettingMin,
                    max: inputData.desiredRSettingMax
                }
            } else if (inputData.desiredRSetting === 2) {
                payload.rules.desiredR = {
                    min: inputData.desiredRSettingMax,
                    max: inputData.desiredRSettingMax
                }
            } else {
                payload.rules.desiredR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.undesiredRSetting) {
                payload.rules.undesiredR = {
                    min: inputData.undesiredRSettingMin,
                    max: inputData.undesiredRSettingMax
                }
            } else if (inputData.undesiredRSetting === 2) {
                payload.rules.undesiredR = {
                    min: inputData.undesiredRSettingMax,
                    max: inputData.undesiredRSettingMax
                }
            } else {
                payload.rules.undesiredR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.weekendRSetting) {
                payload.rules.weekendR = {
                    min: inputData.weekendRSettingMin,
                    max: inputData.weekendRSettingMax
                }
            } else if (inputData.weekendRSetting === 2) {
                payload.rules.weekendR = {
                    min: inputData.weekendRSettingMax,
                    max: inputData.weekendRSettingMax
                }
            } else {
                payload.rules.weekendR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.weekendDaysRSetting) {
                payload.rules.weekendDaysR = {
                    min: inputData.weekendDaysRSettingMin,
                    max: inputData.weekendDaysRSettingMax
                }
            } else if (inputData.weekendDaysRSetting === 2) {
                payload.rules.weekendDaysR = {
                    min: inputData.weekendDaysRSettingMax,
                    max: inputData.weekendDaysRSettingMax
                }
            } else {
                payload.rules.weekendDaysR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.skillRSetting) {
                payload.rules.skillR = {
                    min: 0,
                    max: 1
                }
            } else if (inputData.skillRSetting === 2) {
                payload.rules.skillR = {
                    min: 1,
                    max: 1
                }
            } else {
                payload.rules.skillR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.fairnessDefinitionRSetting) {
                payload.rules.fairnessDefinitionR = {
                    min: inputData.fairnessDefinitionRSettingMin,
                    max: inputData.fairnessDefinitionRSettingMax
                }
            } else if (inputData.fairnessDefinitionRSetting === 2) {
                payload.rules.fairnessDefinitionR = {
                    min: inputData.fairnessDefinitionRSettingMax,
                    max: inputData.fairnessDefinitionRSettingMax
                }
            } else {
                payload.rules.fairnessDefinitionR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.bioRSetting) {
                payload.rules.bioR = {
                    min: inputData.bioRSettingMin,
                    max: inputData.bioRSettingMax
                }
            } else if (inputData.bioRSetting === 2) {
                payload.rules.bioR = {
                    min: inputData.bioRSettingMax,
                    max: inputData.bioRSettingMax
                }
            } else {
                payload.rules.bioR = {
                    min: 0,
                    max: 0
                }
            }

           

            payload.employeeCountMax = null;

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$store.commit("setEmployeeRulesTemplateMapEntry", response.data.data);
                
                
                view.loadingStop();
                view.$helpers.success( view.$t('store.templates.createdTemplate') , response.data.data.name);

            }).catch(function (error) {
                view.loadingStop();
                view.$helpers.error(view.$t('global.notifications.error'), error);
                console.log(error)
            })

        },

        openCreatePopup() {
            let view = this;
            let dataEntries = [{
                    label: this.$t('pages.employeeData.name') + ': ',
                    key: 'name',
                    hidden: false,
                    type: 'text',
                    value: '',
                    length: 128,
                    styles: {
                        'width': '550px'
                    },
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.wishes'),
                    key: 'desiredRSetting',
                    hidden: false,
                    type: 'bool',
                    value: false,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'desiredRSettingMin',
                    hidden: false,
                    hiddenBoundToInverse: 'desiredRSetting',
                    type: 'slider',
                    value: 0,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 0,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'desiredRSettingMax',
                    hidden: false,
                    hiddenBoundToInverse: 'desiredRSetting',
                    type: 'slider',
                    value: 10,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 10,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.dislikes'),
                    key: 'undesiredRSetting',
                    hidden: false,
                    type: 'bool',
                    value: false,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'undesiredRSettingMin',
                    hidden: false,
                    hiddenBoundToInverse: 'undesiredRSetting',
                    type: 'slider',
                    value: 0,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 0,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'undesiredRSettingMax',
                    hidden: false,
                    hiddenBoundToInverse: 'undesiredRSetting',
                    type: 'slider',
                    value: 10,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 10,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.freeWeekends'),
                    key: 'weekendRSetting',
                    hidden: false,
                    type: 'bool',
                    value: false,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'weekendRSettingMin',
                    hidden: false,
                    hiddenBoundToInverse: 'weekendRSetting',
                    type: 'slider',
                    value: 0,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 0,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'weekendRSettingMax',
                    hidden: false,
                    hiddenBoundToInverse: 'weekendRSetting',
                    type: 'slider',
                    value: 10,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 10,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.freeWeekendDays'),
                    key: 'weekendDaysRSetting',
                    hidden: false,
                    type: 'bool',
                    value: false,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'weekendDaysRSettingMin',
                    hidden: false,
                    hiddenBoundToInverse: 'weekendDaysRSetting',
                    type: 'slider',
                    value: 0,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 0,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'weekendDaysRSettingMax',
                    hidden: false,
                    hiddenBoundToInverse: 'weekendDaysRSetting',
                    type: 'slider',
                    value: 10,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 10,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.skillPlanning'),
                    key: 'skillRSetting',
                    hidden: false,
                    type: 'bool',
                    value: false,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.fairness'),
                    key: 'fairnessDefinitionRSetting',
                    hidden: false,
                    type: 'bool',
                    value: false,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'fairnessDefinitionRSettingMin',
                    hidden: false,
                    hiddenBoundToInverse: 'fairnessDefinitionRSetting',
                    type: 'slider',
                    value: 0,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 0,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'fairnessDefinitionRSettingMax',
                    hidden: false,
                    hiddenBoundToInverse: 'fairnessDefinitionRSetting',
                    type: 'slider',
                    value: 10,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 10,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.biorhythm'),
                    key: 'bioRSetting',
                    hidden: false,
                    type: 'bool',
                    value: false,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'bioRSettingMin',
                    hidden: false,
                    hiddenBoundToInverse: 'bioRSetting',
                    type: 'slider',
                    value: 0,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 0,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'bioRSettingMax',
                    hidden: false,
                    hiddenBoundToInverse: 'bioRSetting',
                    type: 'slider',
                    value: 10,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: 10,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    flexDivider: true,
                    styles: {
                        'margin-bottom': '23px'
                    }
                },
            ];

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                pointerDirection: -1,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (inputData) {
                        view.createRuleTemplate(inputData);
                    },
                    deleteCallback: function () {},
                    negativeButtonLabel: this.$t('global.ui.cancel'),
                },
                header: this.$t('store.templates.createLeisureTemplate'),
                remainAfterSelect: false,
                width: '700px',
                centered: true,
                expanded: true,
            });
        },

        openEditPopup(template, uxdisabled = false) {
            let view = this;
            let dataEntries = [{
                    label: this.$t('pages.employeeData.name') + ': ',
                    key: 'name',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    type: 'text',
                    value: template.name,
                    length: 128,
                    styles: {
                        'width': '550px'
                    },
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: '',
                    key: 'id',
                    hidden: true,
                    type: '',
                    value: template.id
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.wishes'),
                    key: 'desiredRSetting',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    type: 'bool',
                    value: this.ruleSettingMap[template.id].desiredRSetting,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'desiredRSettingMin',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'desiredRSetting',
                    type: 'slider',
                    value: template.rules.desiredR.min,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.desiredR.min,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'desiredRSettingMax',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'desiredRSetting',
                    type: 'slider',
                    value: template.rules.desiredR.max,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.desiredR.max,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.dislikes'),
                    key: 'undesiredRSetting',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    type: 'bool',
                    value: this.ruleSettingMap[template.id].undesiredRSetting,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'undesiredRSettingMin',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'undesiredRSetting',
                    type: 'slider',
                    value: template.rules.undesiredR.min,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.undesiredR.min,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'undesiredRSettingMax',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'undesiredRSetting',
                    type: 'slider',
                    value: template.rules.undesiredR.max,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.undesiredR.max,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.freeWeekends'),
                    key: 'weekendRSetting',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    type: 'bool',
                    value: this.ruleSettingMap[template.id].weekendRSetting,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'weekendRSettingMin',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'weekendRSetting',
                    type: 'slider',
                    value: template.rules.weekendR.min,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.weekendR.min,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'weekendRSettingMax',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'weekendRSetting',
                    type: 'slider',
                    value: template.rules.weekendR.max,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.weekendR.max,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.freeWeekendDays'),
                    key: 'weekendDaysRSetting',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    type: 'bool',
                    value: this.ruleSettingMap[template.id].weekendDaysRSetting,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'weekendDaysRSettingMin',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'weekendDaysRSetting',
                    type: 'slider',
                    value: template.rules.weekendDaysR.min,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.weekendDaysR.min,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'weekendDaysRSettingMax',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'weekendDaysRSetting',
                    type: 'slider',
                    value: template.rules.weekendDaysR.max,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.weekendDaysR.max,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.skillPlanning'),
                    key: 'skillRSetting',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    type: 'bool',
                    value: this.ruleSettingMap[template.id].skillRSetting,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.fairness'),
                    key: 'fairnessDefinitionRSetting',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    type: 'bool',
                    value: this.ruleSettingMap[template.id].fairnessDefinitionRSetting,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'fairnessDefinitionRSettingMin',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'fairnessDefinitionRSetting',
                    type: 'slider',
                    value: template.rules.fairnessDefinitionR.min,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.fairnessDefinitionR.min,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'fairnessDefinitionRSettingMax',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'fairnessDefinitionRSetting',
                    type: 'slider',
                    value: template.rules.fairnessDefinitionR.max,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.fairnessDefinitionR.max,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    label: this.$t('store.templates.biorhythm'),
                    key: 'bioRSetting',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    type: 'bool',
                    value: this.ruleSettingMap[template.id].bioRSetting,
                    labelStyles: {
                        'font-family': 'DistrictProBold'
                    }
                },
                {
                    label: this.$t('store.templates.minWeight'),
                    key: 'bioRSettingMin',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'bioRSetting',
                    type: 'slider',
                    value: template.rules.bioR.min,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.bioR.max,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    label: this.$t('store.templates.maxWeight'),
                    key: 'bioRSettingMax',
                    uxdisabled: uxdisabled,
                    hidden: false,
                    hiddenBoundToInverse: 'bioRSetting',
                    type: 'slider',
                    value: template.rules.bioR.max,
                    slider: {
                        min: 0,
                        max: 10,
                        step: 1,
                        value: template.rules.bioR.max,
                        labelled: true,
                        inputControl: true,
                        sliderInput: (x) => { return x },
                    }
                },
                {
                    divider: true
                },
                {
                    flexDivider: true,
                    styles: {
                        'margin-bottom': '23px'
                    }
                },
            ];

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                pointerDirection: -1,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (inputData) {
                        if (!uxdisabled) {
                            console.log(inputData);
                            view.editRuleTemplate(inputData);
                        }
                    },
                    deleteCallback: uxdisabled ? null : function () {},
                    positiveButtonLabel: uxdisabled ? this.$t('global.ui.close') : this.$t('global.ui.save'),
                    negativeButtonLabel: this.$t('global.ui.cancel'),
                },
                header: uxdisabled? this.$t('store.templates.details') : this.$t('store.templates.edit'),
                remainAfterSelect: false,
                width: '700px',
                centered: true,
                expanded: true,
            });
        },
        editRuleTemplate(inputData) {
            let view = this;
            view.loadingStart();
            let url = '/api/sec/ruletemplate';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/ruletemplate');

            let payload = {
                id: inputData.id,
                updateFields: ["name", "rules", "employeeCountMax"],
                name: inputData.name,
                rules: {}
            }

            if (inputData.desiredRSetting) {
                payload.rules.desiredR = {
                    min: inputData.desiredRSettingMin,
                    max: inputData.desiredRSettingMax
                }
            } else if (inputData.desiredRSetting === 2) {
                payload.rules.desiredR = {
                    min: inputData.desiredRSettingMax,
                    max: inputData.desiredRSettingMax
                }
            } else {
                payload.rules.desiredR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.undesiredRSetting) {
                payload.rules.undesiredR = {
                    min: inputData.undesiredRSettingMin,
                    max: inputData.undesiredRSettingMax
                }
            } else if (inputData.desiredRSetting === 2) {
                payload.rules.undesiredR = {
                    min: inputData.undesiredRSettingMax,
                    max: inputData.undesiredRSettingMax
                }
            } else {
                payload.rules.undesiredR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.weekendRSetting) {
                payload.rules.weekendR = {
                    min: inputData.weekendRSettingMin,
                    max: inputData.weekendRSettingMax
                }
            } else if (inputData.weekendRSetting === 2) {
                payload.rules.weekendR = {
                    min: inputData.weekendRSettingMax,
                    max: inputData.weekendRSettingMax
                }
            } else {
                payload.rules.weekendR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.weekendDaysRSetting) {
                payload.rules.weekendDaysR = {
                    min: inputData.weekendDaysRSettingMin,
                    max: inputData.weekendDaysRSettingMax
                }
            } else if (inputData.weekendDaysRSetting === 2) {
                payload.rules.weekendDaysR = {
                    min: inputData.weekendDaysRSettingMax,
                    max: inputData.weekendDaysRSettingMax
                }
            } else {
                payload.rules.weekendDaysR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.skillRSetting) {
                payload.rules.skillR = {
                    min: 0,
                    max: 1
                }
            } else if (inputData.skillRSetting === 2) {
                payload.rules.skillR = {
                    min: 1,
                    max: 1
                }
            } else {
                payload.rules.skillR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.fairnessDefinitionRSetting) {
                payload.rules.fairnessDefinitionR = {
                    min: inputData.fairnessDefinitionRSettingMin,
                    max: inputData.fairnessDefinitionRSettingMax
                }
            } else if (inputData.weekendRSetting === 2) {
                payload.rules.fairnessDefinitionR = {
                    min: inputData.fairnessDefinitionRSettingMax,
                    max: inputData.fairnessDefinitionRSettingMax
                }
            } else {
                payload.rules.fairnessDefinitionR = {
                    min: 0,
                    max: 0
                }
            }

            if (inputData.bioRSetting) {
                payload.rules.bioR = {
                    min: inputData.bioRSettingMin,
                    max: inputData.bioRSettingMax
                }
            } else if (inputData.weekendRSetting === 2) {
                payload.rules.bioR = {
                    min: inputData.bioRSettingMax,
                    max: inputData.bioRSettingMax
                }
            } else {
                payload.rules.bioR = {
                    min: 0,
                    max: 0
                }
            }

            

            payload.employeeCountMax = null;

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                let templateMapItem = view.employeeRulesTemplateMap[inputData.id];
                if (templateMapItem != undefined) {
                    for (let property in payload) {
                        if (payload.hasOwnProperty(property) && templateMapItem.hasOwnProperty(property)) {
                            templateMapItem[property] = payload[property];
                        }
                    }
                }
                view.$store.commit("setEmployeeRulesTemplateMapEntry", templateMapItem);
                view.$store.commit("invalidateState", {states: ["employeeRulesTemplateMapState"]});
                view.loadingStop();
                view.$helpers.success(view.$t('pages.employeeContract.templateSaved'), '');
            }).catch(function (error) {
                view.loadingStop();
                view.$helpers.error(view.$t('global.notifications.error'), error);
                console.log(error)
            })

        },

        openDeletePopup: function (t) {
            let view = this;

            let dataEntries = [{
                label: this.$t('store.templates.deleteLeisureTemplate'),
                key: 'text',
                hidden: false,
                type: 'text',
                length: 128,
                disabled: true,
                styles: {
                    'width': '550px'
                },
                value: t.name
            }
            ];

            this.$helpers.OpenPopup({
                elRelative: null,
                type: 'datafill',
                pointerDirection: -1,
                componentState: {
                    entries: dataEntries,
                    selectCallback: function () {
                        view.deleteRuleTemplate(t.id);
                    },
                    deleteCallback: function () {},
                    negativeButtonLabel: this.$t('global.ui.cancel'),
                    positiveButtonLabel: this.$t('global.ui.delete'),
                },
                header: this.$t('pages.employeeContract.deleteTemplate'),
                remainAfterSelect: false,
                width: '700px',
                centered: true,
                expanded: true,
            });
        },
        deleteRuleTemplate(templateId) {
            let view = this;
            view.loadingStart();
            let url = '/api/sec/ruletemplate';

            url = this.$helpers.appendParam("id", templateId, url, '/api/sec/ruletemplate');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeetypetemplate');

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$store.commit("deleteEmployeeRulesTemplateMapEntry", {id: templateId});
                view.$store.commit("invalidateState", {states: ["employeeRulesTemplateMapState"]});
                view.loadingStop();
                view.$helpers.success(view.$t('store.templates.deleted'), '');
            }).catch(function (error) {
                console.log(error)
                view.loadingStop();
                view.$helpers.error(view.$t('global.notifications.error'), error);
            })

        },
       
        
        
        determineRadioSetting(min, max) {
            if (min == max && max != 0) {
                return 2;
            } else if (min > 0 || max > 0) {
                return 1;
            } else {
                return 0;
            }
        },
        hideModalWithoutReset(ref) {
            this.templateerror = false;
            this.$refs[ref].hide();
        },
        resetRuleTemplateValues() {
            this.ruleTemplate = {
                name: "",
                desiredRSetting: 0,
                desiredRMin: 0,
                desiredRMax: 0,
                undesiredRSetting: 0,
                undesiredRMin: 0,
                undesiredRMax: 0,
                weekendRSetting: 0,
                weekendRMin: 0,
                weekendRMax: 0,
                weekendDaysRSetting: 0,
                weekendDaysRMin: 0,
                weekendDaysRMax: 0,
                skillRSetting: 0,
                fairnessDefinitionRSetting: 0,
                fairnessDefinitionRMin: 0,
                fairnessDefinitionRMax: 0,
                bioRSetting: 0,
                bioRMin: 0,
                bioRMax: 0,
                limitEmployeeCount: false,
                employeeCountMax: null

            }
        },

        hideModal(ref) {

            this.resetRuleTemplateValues();

            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        }
    }
    

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->

<style scoped>

</style>
